<button
(click)="onRedeemed()"
class="btn btn-redeemed text-capitalize"
[ngClass]="{'active': active}"
>
  <img class="icon" [src]="image">
  <span>{{label | translate | titlecase}}</span>
</button>

